const shell = document.createElement("template");
shell.innerHTML = `
  <header class="site-header account-header">
    <a class="brand" href="/" aria-label="Back to the MathPop game"><span aria-hidden="true">✦</span><span class="brand-copy"><strong>MathPop!</strong><small>Tiny sums. Huge energy.</small></span></a>
    <a class="back-to-game" href="/">← Back to the game</a>
  </header>
  <main class="account-page" id="main"><mp-auth-panel></mp-auth-panel></main>
  <footer><span><a href="/next/privacy.html">Privacy</a> · <a href="/next/terms.html">Terms</a></span></footer>`;

export class MathpopApp extends HTMLElement {
  connectedCallback(): void {
    this.replaceChildren(shell.content.cloneNode(true));
  }
}

customElements.define("mathpop-app", MathpopApp);
